// extracted by mini-css-extract-plugin
module.exports = {"areas":"areas_areas__2HAn9","box":"areas_box__3YFqp"};